import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const OperatorsModal = ({ show, handleClose, mode, operatorData, onSave }) => {
  const [formData, setFormData] = useState({
    operatorName: '',
    opCode: '',
    serviceName: '',
    status: 'Active',
    logo: '',
    inputFields: 1
  });

  useEffect(() => {
    if (mode === 'edit' && operatorData) {
      setFormData(operatorData);
    } else {
      setFormData({
        operatorName: '',
        opCode: '',
        serviceName: '',
        status: 'Active',
        logo: '',
        inputFields: 1
      });
    }
  }, [mode, operatorData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {mode === 'add' ? 'Add Operator' : 'Edit Operator'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Operator Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="operatorName"
                  value={formData.operatorName}
                  onChange={handleChange}
                  placeholder="e.g., Airtel, Jio"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>24Pay Op Code <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="opCode"
                  value={formData.opCode}
                  onChange={handleChange}
                  placeholder="e.g., OP001"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Service Name <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  name="serviceName"
                  value={formData.serviceName}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Service</option>
                  <option value="Mobile Recharge">Mobile Recharge</option>
                  <option value="DTH Recharge">DTH Recharge</option>
                  <option value="Gas Booking">Gas Booking</option>
                  <option value="Bill Payment">Bill Payment</option>
                  <option value="Broadband">Broadband</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Logo URL</Form.Label>
                <Form.Control
                  type="text"
                  name="logo"
                  value={formData.logo}
                  onChange={handleChange}
                  placeholder="https://example.com/logo.png"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Input Fields</Form.Label>
                <Form.Control
                  type="number"
                  name="inputFields"
                  value={formData.inputFields}
                  onChange={handleChange}
                  min="1"
                  max="10"
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button 
              variant="secondary" 
              onClick={handleClose}
              className="btn-outline-danger-custom"
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              className="btn-outline-primary-custom"
            >
              {mode === 'add' ? 'Add Operator' : 'Update Operator'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default OperatorsModal;

